import { TENANT_PROFILES } from "@/data/project";
import { Utensils, Stethoscope, Briefcase, Wrench } from "lucide-react";

const ICONS = {
  Utensils,
  Stethoscope,
  Briefcase,
  Wrench,
};

const TenantProfiles = () => {
  return (
    <section
      data-testid="tenants-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 text-[var(--co-accent)] uppercase tracking-[0.25em] text-xs font-semibold">
              <span className="h-px w-8 bg-[var(--co-accent)]" />
              05 · Tu negocio aquí
            </span>
            <h2 className="mt-6 font-display text-[var(--co-primary)] text-4xl md:text-5xl font-bold tracking-tight leading-[1.05]">
              Diseñada para
              <br />
              <span className="text-[var(--co-accent)]">negocios ganadores.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pl-10">
            <p className="text-[var(--co-text-muted)] text-lg leading-relaxed">
              Una mezcla comercial pensada para atender las necesidades diarias de miles de
              familias y colaboradores. ¿Cuál es tu próximo negocio?
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--co-border)]">
          {TENANT_PROFILES.map((t, i) => {
            const Icon = ICONS[t.icon] || Briefcase;
            return (
              <div
                key={t.title}
                data-testid={`tenant-profile-${i}`}
                className="bg-white p-8 md:p-10 hover:bg-[var(--co-bg)] transition-colors group"
              >
                <div className="w-12 h-12 border border-[var(--co-border)] flex items-center justify-center group-hover:border-[var(--co-accent)] group-hover:bg-[var(--co-accent)] transition-colors">
                  <Icon className="w-5 h-5 text-[var(--co-primary)] group-hover:text-white transition-colors" />
                </div>
                <p className="mt-6 font-display text-xl font-bold text-[var(--co-primary)] leading-tight">
                  {t.title}
                </p>
                <p className="mt-3 text-sm text-[var(--co-text-muted)] leading-relaxed">
                  {t.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TenantProfiles;
